import * as BaggagePage from './components/BaggagePage.css';
import * as MobileBaggageRules from './components/MobileBaggageRules/MobileBaggageRules.css';

export default {
	BaggagePage,
	MobileBaggageRules
};
